import { Flex, type FlexProps } from '@/ui';
import { useIsColumnLayout } from '../hooks/useIsColumnLayout';

type Props = FlexProps & {
  pollJobSuccess: boolean;
};

export const ContentContainer = ({ pollJobSuccess, ...props }: Props) => {
  const { isColumnLayout } = useIsColumnLayout();

  return (
    <Flex
      align="center"
      direction="column"
      flex="1"
      gap="3"
      minH={0}
      pos="relative"
      overflowY={
        !pollJobSuccess ? 'initial' : isColumnLayout ? 'auto' : 'hidden'
      }
      {...props}
    />
  );
};
